import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { documentsApi } from '../../../lib/api/documentsApi.connect';
export function documentsQueryKey(params) {
    return [
        'editor-documents',
        params.folderId ?? '',
        params.search ?? ''
    ];
}
export function useDocuments(params = {}) {
    return useQuery({
        queryKey: documentsQueryKey(params),
        queryFn: ()=>documentsApi.listDocuments(params),
        staleTime: 30000
    });
}
export function useDocument(id) {
    return useQuery({
        queryKey: [
            'editor-document',
            id
        ],
        queryFn: ()=>id ? documentsApi.getDocument(id) : Promise.reject(new Error('no id')),
        enabled: !!id
    });
}
export function useCreateDocument() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (params)=>documentsApi.createDocument(params),
        onSuccess: (_doc)=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
export function useRenameDocument() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name })=>documentsApi.renameDocument(id, name),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
export function useMoveDocument() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, folderId })=>documentsApi.moveDocument(id, folderId),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
export function useDeleteDocument() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id)=>documentsApi.deleteDocument(id),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
